import {useEffect, useState}from "react";
import styled  from "styled-components";
import Header from './Header';
import Portfolio from './Portfolio';
import Contact from './Contact';
import About from './About';



const HomeStyle = styled.div`

    `


 
function Home(props) {

  let [elementEnter, setElementEnter] = useState(0);
  let [scrollPercentage, setscrollPercentage] = useState(0);

  useEffect(()=>{
 
    
    setscrollPercentage(props.scrollPercentage) //setcrollPecentage eagle to incoming percentage from app.js
    props.elementEnter(elementEnter) // send elementEnter to app.js
    
  },[props, elementEnter]);

  return (
    <HomeStyle>
      <Header/>
    
    <div className="content">
      
      <div className="projecten">
        <Portfolio scrollPercentage={scrollPercentage} elementEnter={elementEnter=>setElementEnter(elementEnter)}/>
      </div>
      <div className="projecten">
        <About/>
      </div>
      <div className="projecten">
        <Contact scrollPercentage={scrollPercentage}/>
      </div>
    </div>
    </HomeStyle>
  );
}
export default Home;